import apiClient from './apiClient';

// ============================================================
// Types — matching backend Go models for R5D5 (Requisition Reversal)
// ============================================================

export interface WriteoffItem {
  fd150_01: string;         // Requisition no (PK)
  fd150_10: string;         // Supplier code
  fd150_11: string;         // Subcontract no
  fd150_12: string | null;  // Entry date (ISO string)
  fd150_90: number;         // Reversal count
  supplier_name: string;    // Supplier name
}

export interface QueryResponse {
  items: WriteoffItem[];
  total: number;
}

export interface ValidateItemResponse {
  valid: boolean;
  message?: string;
}

export interface ExecuteResponse {
  success: number;
  failed: number;
  errors?: string[];
  message: string;
}

// ============================================================
// API methods
// ============================================================

export const r5d5Api = {
  /** Query requisition items within a range */
  async query(startNo: string, endNo: string): Promise<QueryResponse> {
    const res = await apiClient.post('/api/r5d5/query', {
      start_no: startNo,
      end_no: endNo,
    });
    return res.data;
  },

  /** Validate a single item for reversal eligibility */
  async validateItem(requisitionNo: string): Promise<ValidateItemResponse> {
    const res = await apiClient.post('/api/r5d5/validate-item', {
      requisition_no: requisitionNo,
    });
    return res.data;
  },

  /** Execute batch reversal for selected items */
  async execute(requisitionNos: string[]): Promise<ExecuteResponse> {
    const res = await apiClient.post('/api/r5d5/execute', {
      requisition_nos: requisitionNos,
    });
    return res.data;
  },
};
